import React from "react";
import Navbar from "../components/Navbar/Navbar";
import AuthLayout from "../components/Auth/AuthLayout";
import ForgotPasswordForm from "../components/Auth/ForgotPasswordForm";
import forgotBg from "./../assets/signup-bg.jpg";

function ForgotPassword() {
  return (
    <>
      <Navbar />
      <AuthLayout backgroundImage={forgotBg}>
        <ForgotPasswordForm />
      </AuthLayout>
    </>
  );
}

export default ForgotPassword;
